module.exports = __webpack_public_path__ + "static/media/pagimovel-corretores.67570521.png";